<template>
  <div class="container admin">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>权限管理</el-breadcrumb-item>
        <el-breadcrumb-item>部门管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">部门管理</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="handleCreate"
          >添加部门</el-button>
        </div>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">部门列表</p>
      </div>
      <el-table
        :data="roles"
        style="width: 100%;margin-bottom: 20px;"
        row-key="id"
        border
        default-expand-all
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
        <el-table-column
          type="index"
          label="序号"
          width="70"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="部门"
          align="center"
        > </el-table-column>
        <el-table-column
          prop="address"
          label="人数"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.admin_count + "人" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="director"
          label="负责人"
          width="234"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.director">{{ scope.row.director }}</span>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="description"
          label="部门工作职责"
          width="400"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.description">{{ scope.row.description }}</span>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="address"
          label="操作"
          width="172"
          align="center"
        >
          <template slot-scope="scope">
            <el-link
              type="primary"
              :underline="false"
              @click="handlToEdit(scope.row)"
            >编辑</el-link>
            <el-link
              type="danger"
              :underline="false"
              @click="handleToDelete(scope.row)"
            >
              删除
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <DeptCreate
      :visible="DeptCreateDialog"
      @close="DeptCreateDialog=false"
      @submit="fetchList()"
    />
    <DeptEdit
      :visible="DeptEditDialog"
      @close="DeptEditDialog=false"
      :content="DeptEditContent"
      @submit="fetchList()"
    />
  </div>
</template>

<script>
import { deptlist, deptDestroy } from '@/api/admin'
import DeptCreate from '@/components/dialog/admin/DeptCreate.vue'
import DeptEdit from '@/components/dialog/admin/DeptEdit.vue'
export default {
  components: {
    DeptCreate,
    DeptEdit
  },
  data() {
    return {
      DeptCreateDialog: false,
      editDialog: false,
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize') ? Number(localStorage.getItem('pageSize')) : 10,
        isPaging: 1
      },
      pageTotal: 1000,
      roles: [],
      editRow: {},
      isfixed: document.body.clientWidth < 820 ? false : true,
      DeptCreateDialog: false,
      DeptEditDialog: false,
      DeptEditContent: {},
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    // 角色列表
    fetchList() {
      deptlist(this.query).then(res => {
        this.roles = res.list || []
        this.pageTotal = res.count || 0
      })
    },
    handleCreate() {
      this.DeptCreateDialog = true
    },
    //分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchList()
    },
    handlToEdit(row) {
      this.DeptEditContent = JSON.parse(JSON.stringify(row))
      this.DeptEditDialog = true
    },
    // 角色删除
    handleToDelete(item, index) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        deptDestroy({ id: item.id }).then(res => {
          this.$message.success(`删除成功`)
          this.fetchList()
        })
      }).catch(() => { })

    }
  }
}
</script>

<style scoped lang="less">
.admin {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
.el-link {
  margin: 0px 5px;
  font-size: 12px;
}
</style>

